import React from 'react';
import TimeRangePicker from '@lib/components/DateTimePicker/TimeRangePicker';
import { ComponentProps, defaultProps } from '../types';

export default function TimeRangePreview({ t }: ComponentProps) {
  return <TimeRangePicker {...defaultProps} label={t('select-time-range')} />;
}
